const elementClone = (blockId, cloneELementId) => {
  
  const elementClone = document.getElementById(blockId)
  const element = document.getElementById(cloneELementId)
  
  let removeElement = elementClone.querySelector(`#${blockId} #iframe`)
  console.log(removeElement)

  if (removeElement) {
    removeElement.remove()
  }

  elementClone.append(element)
}

export default {
  elementClone
}